import * as React from 'react';
import * as tenantService from 'services/tenant-service';
import * as sessionTimeoutService from 'services/session-timeout-service';
import AuditLogs from 'components/audit-logs';
import CertaHeader from 'components/header';
// import DeviceRegistrationPage from 'pages/device-registration';
import LoginPage from 'pages/login';
import Main from 'components/main';
import MenuWrapper from 'components/menu-wrapper';
import SettingsPage from 'pages/settings';
import UsersPage from 'pages/users';
// import TermsPage from 'pages/terms-of-use';
import DeviceInfoPage from 'pages/device-info';
import UserProfilePage from 'pages/user-profile';
import { CertaFooter } from 'components/footer';
import { Container, Loader } from 'semantic-ui-react';
import { syncData } from 'service-worker/data-syncs/data-sync';
import { Route, Switch, Redirect, RouteComponentProps } from 'react-router-dom';
import { PermissionRoute } from 'components/permission-route';
import { Permission } from 'types/permission';
// import { ChatButton } from 'components/chat-button';
import { UserManagementPage } from 'pages/user-management';
import { translations } from 'types/translations';
import { getI18n } from 'services/i18n-service';

import './styles.css';

export interface AppProps {
  tenantIdExists: boolean;
  termsAccepted: boolean;
  loggedIn: boolean;
  permissions: string;
  hasEnterpriseLogin?: boolean;
}

export interface AppActionProps {
  getTenantIdExists: () => void;
  getTenantFromCache: () => void;
  listRows: () => void;
  listAlerts: () => void;
  refresh: () => void;
}

type Props = AppProps & AppActionProps & RouteComponentProps;

const RedirectToMain: React.StatelessComponent = () => {
  return (<Redirect to={`${process.env.PUBLIC_URL}/`} />);
};

export class App extends React.Component<Props> {

  componentDidMount() {
    syncData();
    this.props.getTenantIdExists();
    this.props.getTenantFromCache();
    this.props.listRows();
    this.props.listAlerts();
    this.props.refresh();
    tenantService.translateToTenantLanguage();
    window.addEventListener('click', this.refreshAction);
    window.addEventListener('keydown', this.refreshAction);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.refreshAction);
    window.removeEventListener('keydown', this.refreshAction);
  }

  refreshAction = () => {
    sessionTimeoutService.refreshLastAction();
  }

  public render() {
    let content: JSX.Element;

    if (this.props.loggedIn === undefined || this.props.tenantIdExists === undefined) {
      const i18n = getI18n();
      content = (
        <Container className="container-main" >
          <Loader active={true} content={i18n.t(translations.LoadingCerta)} />
        </Container>
      );
    } else if (this.props.loggedIn === true) {
      content = (
        <div className="container-main-app">
          <MenuWrapper>
            <div className="container-right">
              <div className="header-certa">
                <CertaHeader />
              </div>
              <div className="content-certa">
                <Switch>
                  <Route key="main" exact={true} path={`${process.env.PUBLIC_URL}/`} component={Main} />
                  <Route key="deviceInfo" exact={true} path={`${process.env.PUBLIC_URL}/deviceInfo`} component={DeviceInfoPage} />
                  {
                    this.props.hasEnterpriseLogin === false
                      ? <Route key="userProfile" exact={true} path={`${process.env.PUBLIC_URL}/user/profile`} component={UserProfilePage} />
                      : null
                  }
                  {
                    this.props.hasEnterpriseLogin === false
                      ? <PermissionRoute key="users" exact={true} path={`${process.env.PUBLIC_URL}/users`} component={UsersPage}
                        permissions={[Permission.Users]} />
                      : null
                  }
                  <PermissionRoute key="userManagement" exact={true} path={`${process.env.PUBLIC_URL}/user/:mode(edit|create)`} component={UserManagementPage}
                    permissions={[Permission.Users]} />
                  <PermissionRoute key="settings" exact={true} path={`${process.env.PUBLIC_URL}/settings`} component={SettingsPage}
                    permissions={[Permission.TenantProviderCredentials, Permission.TenantCustomSettings,
                    Permission.TenantPreferences]} />
                  <Route path="*" component={RedirectToMain} />
                </Switch>
              </div>
              <div className="footer-certa">
                <AuditLogs />
              </div>
            </div>
          </MenuWrapper>
          <CertaFooter />
        </div>
      );
    } else {
      content = (
        <LoginPage />
      );
    }
    /* else if (this.props.loggedIn && this.props.termsAccepted !== true) {
      content = (
        <TermsPage />
      );
    } */ 

    return (
      <>
        {content}
        {/* <ChatButton /> */}
      </>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/app/component.tsx